import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Department, DepartmentRequest } from './DepartmentTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Department>>('/departments/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Department>(`/departments/${id}`).then(getData);
}

export function getDepartments() {
  return axios.get<Department[]>('/departments').then(getData);
}

export function getAccessibleDepartments() {
  return axios.get<Department[]>('/departments/accessible').then(getData);
}

export function getDepartmentsAsHeadOf() {
  return axios.get<Department[]>('/departments/where-head-of').then(getData);
}

export function getDepartmentsByFaculty(facultyId: Id) {
  return axios.get<Department[]>(`/departments/by-faculty/${facultyId}`).then(getData);
}

export function create(request: DepartmentRequest) {
  return axios.post<Department>(`/departments/faculty`, request).then(getData);
}

export function edit(id: Id, request: DepartmentRequest) {
  return axios.put<Department>(`/departments/${id}`, request).then(getData);
}
